module.exports = __webpack_public_path__ + "static/img/homeBg.86e0027.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/homeBg.png
// module id = vGzI
// module chunks = 1